module.exports = __webpack_public_path__ + "static/media/PDF4.c5902d4e.pdf";